export enum MassiveServiceFlags {
  /** Load the table of request */
  LOAD_SERVICES_TABLE,
  /** This flag is controlled by the button */
  CREATE_SERVICES,
  /** Activates the progress modal */
  ROUTING_PACKAGES,
  /** Enable the button to close the progress modal when something fail */
  ROUTING_FAIL,
  /** */
  SHOW_MAP_FULLSCREEN,
  /** */
  SHOW_FILTERS,
  /** */
  SHOW_MAP,
  /** */
  SHOW_LOAD_FILE,
  /** */
  UPLOAD_FILE,
  /** */
  FILE_LOADED,
  /** */
  SHOW_ERROR_MODAL,
  /**
   * Aplly filters
   */
  APPLY_FILTERS,
}
